import { render } from "./tables-basic.vue?vue&type=template&id=65751966"
import script from "./tables-basic.vue?vue&type=script&lang=js"
export * from "./tables-basic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__